module.exports = __webpack_public_path__ + "static/media/printer_qr_code.eda9657c.jpg";